var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusSign = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8766 7.61719C15.8766 8.31924 15.8166 8.88672 15.1253 8.88672H9.62659V14.4714C9.62659 15.1722 9.06784 15.2344 8.37659 15.2344C7.68534 15.2344 7.12659 15.1722 7.12659 14.4714V8.88672H1.62784C0.937837 8.88672 0.876587 8.31924 0.876587 7.61719C0.876587 6.91514 0.937837 6.34766 1.62784 6.34766H7.12659V0.762988C7.12659 0.0609373 7.68534 0 8.37659 0C9.06784 0 9.62659 0.0609373 9.62659 0.762988V6.34766H15.1253C15.8166 6.34766 15.8766 6.91514 15.8766 7.61719Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-sign.f4e8020767a00b3ccf6e75745ad18bdb.svg";